const Getters = {}

export default Getters
